module.exports = __webpack_public_path__ + "img/three-stars.c9297adf.svg";